import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import {
  createContext,
  FunctionComponent,
  ReactElement,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useSearchParams } from "react-router-dom";

export const BiometricContext = createContext(null);

type Props = {
  children: ReactElement;
};

const BiometricProvider: FunctionComponent<Props> = ({ children }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [paramId, setParamId] = useState("");

  const params = new URLSearchParams(searchParams);

  const { data, isLoading, error, isFetching, refetch } = useQuery({
    queryKey: ["biometric"],
    enabled: !!paramId,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`onboarding/profiles/${paramId}/biometrics`);

      return data;
    },
  });

  useEffect(() => {
    if (params.get("id")) {
      setParamId(params.get("id"));
    } else {
      setParamId("");
    }
  }, [params.get("id")]);

  const handleSDKBack = () => {
    params.delete("id");
    params.delete("r");
    params.delete("action");
    setParamId("");
    setSearchParams(params);
  };

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      refetch,
      handleSDKBack,
    }),
    [isLoading, data, error, isFetching, refetch, handleSDKBack],
  );
  return (
    <BiometricContext.Provider value={contextValue}>
      {children}
    </BiometricContext.Provider>
  );
};

export default BiometricProvider;
